module.exports = __webpack_public_path__ + "img/cloud-snow.fe94a3de.svg";